import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import { ServiceScheduleDashboardRoutingModule } from './service-schedule-dashboard-routing.module';
import { ServiceScheduleDashboardComponent } from './service-schedule-dashboard.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { OverrideDialogComponent } from './override-dialog/override-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ServiceScheduleDashboardComponent,
        OverrideDialogComponent],
    imports: [
        CommonModule,
        SharedModule,
        ServiceScheduleDashboardRoutingModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        TranslateModule
    ],
    exports: [TranslateModule]
})
export class ServiceScheduleDashboardModule {
}
